const appConfig = {
  appURL: process.env.REACT_APP_APP_URL || 'https://naramky.neurosmart.cz',
  apiURL: process.env.REACT_APP_API_URL || 'https://iotportal.soitron.sk/api',
  protectedURL: process.env.REACT_APP_public_URL || 'https://naramky.neurosmart.cz/protected',
  neurosmartID: "36317c40-87b0-11ed-8a67-f3cfa2e06318",
  caretakersID: "05264d50-1fd7-11ee-9f53-61216da9c7cb",
};

export default appConfig;
